export default {
  usuarios: [],
  usuarioActual: null,
  usuarioActualObj: { nombre: "Sin User" },
  eleccionUsuarioDialog: false,
  eleccionUsuarioAdminAccionesDialog: false,
  eleccionUsuarioAdminAccionesObj: {},
  eleccionUsuarioAdminAccionesRespuesta: { ok: false },
};
